export type MfaPendingResponse = {
  requiresMfa: true;
  mfaToken: string;
  setupRequired: boolean;
  message?: string;
};

export type MfaSetupResponse = {
  setupKey: string;
  manualEntryKey: string;
  qrCodeImageUrl: string;
};

export type MfaVerifyPayload = {
  mfaToken: string;
  code: string;
  setupKey?: string;
};

export const MFA_SESSION_KEY = 'portal_mfa_pending';

export const isMfaPendingResponse = (
  response: unknown,
): response is MfaPendingResponse => {
  if (!response || typeof response !== 'object') return false;
  const data = response as Record<string, unknown>;
  return data.requiresMfa === true && typeof data.mfaToken === 'string';
};

export class MfaRequiredError extends Error {
  readonly mfa: MfaPendingResponse;

  constructor(mfa: MfaPendingResponse) {
    super('MFA_REQUIRED');
    this.name = 'MfaRequiredError';
    this.mfa = mfa;
  }
}
